import React, { ComponentType } from 'react';
import { usePlan } from 'data/plan/usePlan';
import { useAnalyticsPageView } from './useAnalyticsPageView';

export const withAnalyticsPageView =
  (pageWithoutMarket: string) =>
  <P,>(WrappedComponent: ComponentType<P>) =>
  (props: P) => {
    const { planType } = usePlan();
    useAnalyticsPageView(planType, pageWithoutMarket);
    return <WrappedComponent {...props} />;
  };

export default withAnalyticsPageView;
